
export default function Headerportfolio() {
    
    return(
        <div className="flex flex-col justify-center" id="headerportfolio">
        <h2 className="text-4xl tracking-tight font-extrabold text-indigo-100 sm:text-3xl md:text-4xl mx-auto mt-10">Portfolio</h2>
        <p className="mt-3 text-base text-gray-400 sm:text-lg sm:max-w-xl sm:mx-auto md:text-xl mx-auto">Switch between my Projects</p>
            <div className="flex flex-row justify-center gap-5 mt-5">
            <button id="websitesbtn" onClick={renderWP} className="w-25 hover:scale-105 cursor-pointer flex items-center justify-center px-4 py-2 border border-transparent font-bold text-white font-medium rounded-md bg-orange-600 hover:bg-orange-700">Websites / Shops</button>
            <button id="javascriptbtn" onClick={renderJS} className="javascriptbtn w-25 hover:scale-105 cursor-pointer flex items-center justify-center px-4 py-2 border border-transparent font-bold text-white font-medium rounded-md text-neutral-900 bg-orange-600 hover:bg-orange-700">JavaScript</button>
            <button id="landingpagesbtn" onClick={renderLP} className="w-25 hover:scale-105 cursor-pointer flex items-center justify-center px-4 py-2 border border-transparent font-bold text-white font-medium rounded-md text-neutral-900 bg-orange-600 hover:bg-orange-700">Landingpages</button>
            <button id="reactbtn" onClick={renderReact} className="w-25 hover:scale-105 cursor-pointer flex items-center justify-center px-4 py-2 border border-transparent font-bold text-white font-medium rounded-md text-neutral-900 bg-orange-600 hover:bg-orange-700">React</button>
            </div>
        </div>
    )
    function resetColorsBtn() {
        const websitesbtn = document.getElementById("websitesbtn")
        const javascriptbtn = document.getElementById("javascriptbtn")
        const landingpagesbtn = document.getElementById("landingpagesbtn")
        const reactbtn = document.getElementById("reactbtn")

        websitesbtn.style.color = "black"
        javascriptbtn.style.color = "black"
        landingpagesbtn.style.color = "black"
        reactbtn.style.color = "black"
    }
    function renderJS() {
        const js = [
            {img: './assets/images/2022-05-10-19-54-simonxdev-browserdashboard.netlify.app.png', name: 'Chrome Browser Dashboard', tech: 'HTML, CSS, JavaScript, API', text: 'Chrome Browser Dashboard Plugin', link: 'https://browser-dashboard-chrome.netlify.app/' },
            {img: './assets/images/cardgame.netlify.app.png', name: 'War Card Game', tech: 'HTML, CSS, JavaScript', text: 'A Card Game', link: 'https://simonxdev-war-cardgame.netlify.app/' },
            {img: './assets/images/2022-05-11-21-06-simonxdev-colorschemegenerator.netlify.app.png', name: 'Color Scheme Generator', tech: 'HTML, CSS, JavaScript', text: 'A Generator for Color Schemes loading from API', link: 'https://simonxdev-colorschemegenerator.netlify.app/' },
            {img: './assets/images/2022-05-11-21-03-simonxdev-movie-watchlist.netlify.app.png', name: 'Movie Search App', tech: 'HTML, CSS, JavaScript, Tailwind CSS', text: 'App for searching Movies from Imdb API', link: 'https://simonxdev-movie-watchlist.netlify.app/' },
            {img: './assets/images/2022-05-11-21-10-simonxdev-christmas-audio-player.netlify.app.png', name: 'Christmas Audio Player', tech: 'HTML, CSS, JavaScript', text: 'A Christmas Audio Player', link: 'https://simonxdev-christmas-audio-player.netlify.app/' },
            {img: './assets/images/2022-05-11-21-15-simonxdev-roll-the-dice.netlify.app.png', name: 'Roll the Dice Game', tech: 'HTML, CSS, JavaScript', text: 'A roll the Dice Game', link: 'https://simonxdev-roll-the-dice.netlify.app/' },
            {img: './assets/images/2022-05-11-21-18-simonxdev-slider.netlify.png', name: 'A custom Slider', tech: 'HTML, CSS, JavaScript', text: 'Custom Slider with Animation', link: 'https://simonxdev-slider.netlify.app/' },
            {img: './assets/images/2022-05-11-21-27-simonxdev-flexbox-card.netlify.app.png', name: 'Flexbox Card', tech: 'HTML, CSS, JavaScript', text: 'A simple Flexbox Card', link: 'https://simonxdev-flexbox-card.netlify.app/' },
            {img: './assets/images/2022-05-11-21-24-simonxdev-xmasdogsslider.netlify.app.png', name: 'Xmas Dogs Slider', tech: 'HTML, CSS, JavaScript', text: 'A Slider showing Xmas Dogs :)', link: 'https://simonxdev-xmasdogsslider.netlify.app/' },
        ]
        const javascriptbtn = document.getElementById("javascriptbtn")
        const portfoliohtml = document.getElementById("portfoliorender")
        resetColorsBtn()
        javascriptbtn.style.color =  "white"
        portfoliohtml.innerHTML = js.map((item) => (  
            `
            <div class="drop-shadow-xl hover:drop-shadow-2xl hover:-translate-y-1 hover:scale-104 duration-300">
                <div class="rounded-lg overflow-hidden">
                <div class="relative overflow-hidden pb-60">
                    <img class="absolute h-full w-full object-cover object-top" src=${item.img} alt=${item.name} />
                </div>
                <div class="relative bg-neutral-900">
                    <div class="py-10 px-8">
                    <h3 class="text-2xl font-bold text-orange-600">${item.name}</h3>
                    <div class="text-white text-sm font-medium flex mb-4 mt-2">
                        <p>${item.tech}</p>
                    </div>
                    <p class="leading-7 text-white">
                        ${item.text}
                    </p>
                    <div class="mt-10 flex justify-between items-center">
                        <div class="flex">
                        <img src="./assets/images/javascript.svg" width="25px" alt="" class="w-6"/><img src="./assets/images/css.svg" width="25px" alt="" class="w-6 ml-3"/>
                        </div>
                        <a href=${item.link} target="_blank" rel="noreferrer" class="w-1/3 float-right flex items-center font-bold justify-center px-4 py-2 border border-transparent font-medium rounded-md text-neutral-900 bg-orange-600 hover:bg-orange-700">
                        View</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>` 
            )).join('');
        document.getElementById("portfoliorender").scrollIntoView();
    }

    function renderLP() {
        const lp = [
            {img: './assets/images/2022-05-13-21-46-covetrus.de.png', name: 'Products Landingpage', tech: 'HTML, CSS, JavaScript', text: 'Dynamic Landingpage for a Veterinary Shop', link: 'https://covetrus.de/p/covetrusessentials' },
            {img: './assets/images/2022-05-13-21-49-covetrus.ch.png', name: 'Products Landingpage', tech: 'HTML, CSS', text: 'Product Landingpage made from a PSD Template', link: 'https://covetrus.ch/p/carnilove' },
            {img: './assets/images/screencapture-covetrus-ch-p-goood-2022-05-13-21_51_48.png', name: 'Products Landingpage', tech: 'HTML, CSS', text: 'Product Landingpage made from a PSD Template', link: 'https://covetrus.ch/p/goood' },
        ]
        const landingpagesbtn = document.getElementById("landingpagesbtn")
        const portfoliohtml = document.getElementById("portfoliorender")
        resetColorsBtn()
        landingpagesbtn.style.color =  "white"
        portfoliohtml.innerHTML = lp.map((item) => (  
            `
            <div class="drop-shadow-xl hover:drop-shadow-2xl hover:-translate-y-1 hover:scale-104 duration-300">
                <div class="rounded-lg overflow-hidden">
                <div class="relative overflow-hidden pb-60">
                    <img class="absolute h-full w-full object-cover object-top" src=${item.img} alt=${item.name} />
                </div>
                <div class="relative bg-neutral-900">
                    <div class="py-10 px-8">
                    <h3 class="text-2xl font-bold text-orange-600">${item.name}</h3>
                    <div class="text-white text-sm font-medium flex mb-4 mt-2">
                        <p>${item.tech}</p>
                    </div>
                    <p class="leading-7 text-white">
                        ${item.text}
                    </p>
                    <div class="mt-10 flex justify-between items-center">
                        <div class="flex">
                        <img src="./assets/images/javascript.svg" width="25px" alt="" class="w-6"/><img src="./assets/images/css.svg" width="25px" alt="" class="w-6 ml-3"/>
                        </div>
                        <a id="projectbtn" href=${item.link} target="_blank" rel="noreferrer" class="w-1/3 float-right flex items-center font-bold justify-center px-4 py-2 border border-transparent font-medium rounded-md text-neutral-900 bg-orange-600 hover:bg-orange-700">
                        View</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>` 
            )).join('');
        document.getElementById("portfoliorender").scrollIntoView();
    }

    function renderReact() {
        const react = [
            {img: './assets/images/portfolio.jpg', name: 'My Portfolio', tech: 'HTML, Tailwind CSS, React', text: 'My Portfolio Website', link: 'https://simonxdev.netlify.app/' },
            {img: './assets/images/tesla.png', name: 'Tesla Clone', tech: 'HTML, Tailwind CSS, React', text: 'Tesla Website Clone - coming soon', link: '' },
        ]
        const reactbtn = document.getElementById("reactbtn")
        const portfoliohtml = document.getElementById("portfoliorender")
        resetColorsBtn()
        reactbtn.style.color =  "white"
        portfoliohtml.innerHTML = react.map((item) => (  
            `
            <div class="drop-shadow-xl hover:drop-shadow-2xl hover:-translate-y-1 hover:scale-104 duration-300">
                <div class="rounded-lg overflow-hidden">
                <div class="relative overflow-hidden pb-60">
                    <img class="absolute h-full w-full object-cover object-top" src=${item.img} alt=${item.name} />
                </div>
                <div class="relative bg-neutral-900">
                    <div class="py-10 px-8">
                    <h3 class="text-2xl font-bold text-orange-600">${item.name}</h3>
                    <div class="text-white text-sm font-medium flex mb-4 mt-2">
                        <p>${item.tech}</p>
                    </div>
                    <p class="leading-7 text-white">
                        ${item.text}
                    </p>
                    <div class="mt-10 flex justify-between items-center">
                        <div class="flex">
                        <img src="./assets/images/React-icon.svg" width="25px" alt="" class="w-6"/><img src="./assets/images/tailwindcss.svg" width="25px" alt="" class="w-6 ml-3"/>
                        </div>
                        <a id="projectbtn" href=${item.link} target="_blank" rel="noreferrer" class="w-1/3 float-right flex items-center font-bold justify-center px-4 py-2 border border-transparent font-medium rounded-md text-neutral-900 bg-orange-600 hover:bg-orange-700">
                        View</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>` 
            )).join('');
        document.getElementById("portfoliorender").scrollIntoView();
    }

    function renderWP() {
        const wp = [
            {img: './assets/images/2022-05-03-22-28-vhs-henstedt-ulzburg.de.png', name: 'VHS', tech: 'HTML, CSS, JavaScript, PHP', text: 'Wordpress/WooCommerce Website for a local School', link: 'https://vhs-henstedt-ulzburg.de/' },
            {img: './assets/images/2022-05-03-22-54-vbfv.de.png', name: 'VBFV', tech: 'HTML, CSS, JavaScript, PHP', text: 'Wordpress Website for a Insurance Company', link: 'https://vbfv.de' },
            {img: './assets/images/phonecityrepair.png', name: 'PhoneCityRepair', tech: 'HTML, CSS, JavaScript, PHP', text: 'Phone Repair WooCommerce Shop', link: 'https://phonecityrepair.de/' },
            {img: './assets/images/schaedlingsexperten.png', name: 'Schädlingsexperten', tech: 'HTML, CSS, JavaScript, PHP', text: 'Website for a local Company', link: 'https://die-schaedlingsexperten.de/' },
            {img: './assets/images/classicstyle-hh.png', name: 'Classic Style HH', tech: 'HTML, CSS, JavaScript, PHP', text: 'Website for a local Car Dealer', link: 'https://classicstyle-hh.de/' },
            {img: './assets/images/kskingde.png', name: 'KSK Ingenieure', tech: 'HTML, CSS, JavaScript, PHP', text: 'Website for a Engineers Company', link: 'https://ksking.de/' },
        ]
        const websitesbtn = document.getElementById("websitesbtn")
        const portfoliohtml = document.getElementById("portfoliorender")
        resetColorsBtn()
        websitesbtn.style.color =  "white"
        portfoliohtml.innerHTML = wp.map((item) => (  
            `
            <div class="drop-shadow-xl hover:drop-shadow-2xl hover:-translate-y-1 hover:scale-104 duration-300">
                <div class="rounded-lg overflow-hidden">
                <div class="relative overflow-hidden pb-60">
                    <img class="absolute h-full w-full object-cover object-top" src=${item.img} alt=${item.name} />
                </div>
                <div class="relative bg-neutral-900">
                    <div class="py-10 px-8">
                    <h3 class="text-2xl font-bold text-orange-600">${item.name}</h3>
                    <div class="text-white text-sm font-medium flex mb-4 mt-2">
                        <p>${item.tech}</p>
                    </div>
                    <p class="leading-7 text-white">
                        ${item.text}
                    </p>
                    <div class="mt-10 flex justify-between items-center">
                        <div>
                        <img src="./assets/images/WPlogo.png" width="25px" alt="" class="w-6"/>
                        </div>
                        <a href=${item.link} target="_blank" rel="noreferrer" class="w-1/3 float-right flex items-center justify-center font-bold px-4 py-2 border border-transparent font-medium rounded-md text-neutral-900 bg-orange-600 hover:bg-orange-700">
                        View</a>
                    </div>
                    </div>
                </div>
                </div>
            </div>` 
            )).join('');
        
        document.getElementById("portfoliorender").scrollIntoView();
    }
}